import { createSlice } from '@reduxjs/toolkit';
import { REDUX_OPERATIONS } from '../reduxConstants';

const initialState = {
  feeprocedure: [],
};

const feeprocedureSlice = createSlice({
  name: 'feeprocedureSlice',
  initialState,
  reducers: {
    setFeeProcedure: (state, action) => {
      let feeProcedureList = [...state.feeprocedure];
      if (
        action.payload?.operation === REDUX_OPERATIONS.UPDATE &&
        feeProcedureList.some(s => s.sequence === action.payload?.sequence)
      ) {
        feeProcedureList[
          feeProcedureList.findIndex(
            f => f.sequence === action.payload?.sequence
          )
        ] = action.payload?.data;
      } else if (action.payload?.operation === REDUX_OPERATIONS.DELETE) {
        feeProcedureList = feeProcedureList.filter(
          f => f.sequence !== action.payload?.sequence
        );
      } else if (action.payload?.operation === REDUX_OPERATIONS.ADD) {
        feeProcedureList.push(action.payload.data);
      }
      state.feeprocedure = [
        ...feeProcedureList.map((d, idx) => {
          return {
            ...d,
            sequence: idx + 1,
          };
        }),
      ];
    },
    clearFeeProcedure: state => {
      state.feeprocedure = [];
    },
  },
});

export const { setFeeProcedure, clearFeeProcedure } = feeprocedureSlice.actions;

export default feeprocedureSlice.reducer;
